import React, { Component } from "react";
import Image from '../global/Image';

export default class InfoIntro extends Component {
  	
	render() {
		
		const post = this.props.post; 
		
		if (post.intro) {
		
			return (
				
				<div className="c-info__section c-info__section--large-space c-load">
					
					<div className="l-content">
					
						<div className="l-grid">
						
							<div className="l-grid__col">
								
								{post.about &&
									
									<div className="scope-text scope-text--center" dangerouslySetInnerHTML={{__html:post.intro}}></div>
								
								}
								
							</div>
						
						</div>
						
					</div>
				
				</div>
				
			)
			
		} else {
			
			return false;
			
		}
		
	}
							
}